import Tippy from '@tippyjs/react';
import { FunctionComponent, ReactNode, useEffect } from 'react';
import styled from 'styled-components';

import { DefaultButtonStyled } from '@/components/atom/buttons/DefaultButton';
import HeaderCaret from '@/components/atom/icon/Arrow/HeaderCaret';
import NarrowCaret from '@/components/atom/icon/Arrow/NarrowCaret';
import {
  AppHeaderExtendedWrapper,
  AppHeaderLeftButtons,
  AppHeaderWrapper,
  Title,
} from '@/components/molecules/AppHeader/styles';
import { DIRECTION } from '@/types/common';
import { historyBack } from '@/utils/mobile/RNPlugins';

interface AppHeaderProps {
  children?: ReactNode;
  color?: string;
  etcButton?: ReactNode;
  left?: boolean;
  onClickOpenLocationBottomSheet: () => void;
  getHeaderAddress: () => string;
}

const Header: FunctionComponent<AppHeaderProps> = ({
  children,
  color,
  left,
  onClickOpenLocationBottomSheet,
  getHeaderAddress,
}) => {
  let timer: NodeJS.Timeout;

  const address = getHeaderAddress();

  useEffect(() => {
    return () => {
      if (!timer) return;

      clearTimeout(timer);
    };
  }, []);

  return (
    <Container id={'appHeader'}>
      <AppHeaderWrapper color={color} left={left}>
        <AppHeaderLeftButtons>
          <ArrowWrapper onClick={historyBack}>
            <HeaderCaret />
          </ArrowWrapper>
        </AppHeaderLeftButtons>
        <Title>
          <Tippy
            content={
              <TooltipContent>
                <span>찾으시는 위치가 맞나요?</span>
              </TooltipContent>
            }
            arrow
            offset={[0, 20]}
            placement="bottom"
            popperOptions={{
              strategy: 'fixed',
            }}
            zIndex={201}
            showOnCreate
            onCreate={({ hide }) => {
              timer = setTimeout(() => {
                hide();
              }, 3000);
            }}
          >
            <HeaderWrapper onClick={onClickOpenLocationBottomSheet}>
              {address}
              <NarrowCaret direction={DIRECTION.BOTTOM} />
            </HeaderWrapper>
          </Tippy>
        </Title>
      </AppHeaderWrapper>
      <AppHeaderExtendedWrapper>{children}</AppHeaderExtendedWrapper>
    </Container>
  );
};

export default Header;

const Container = styled.div`
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  ${({ theme }) => `
      position: sticky;
      background-color: ${theme.color.white};
      top: 0;
    `};
`;

const TooltipContent = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 7px;
  & > span {
    ${({ theme }) => `
      ${theme.typography.UI14R}
      color: ${theme.color.white};
    `}
  }
`;

const HeaderWrapper = styled(DefaultButtonStyled)`
  ${({ theme }) => `
    ${theme.typography.UI18SB};
  `};

  svg {
    margin-left: 8px;
  }
`;

const ArrowWrapper = styled.button`
  padding: 6px;
  border: none;
  border-radius: 4px;

  &:active {
    background-color: ${({ theme }) => theme.color.gray50};
  }
`;
